import React from "react";
import NextHead from "next/head";
import PropTypes from "prop-types";

const Head = (props) => (
  <NextHead>
    <title>{props.title}</title>
    <meta name="description" content={props.description} />
    <link rel="icon" sizes={props["icon:sizes"]} href={props["icon"]} />
    <link rel="apple-touch-icon" href={props["apple-touch-icon"]} />
    <link
      rel="mask-icon"
      href={props["mask-icon"]}
      color={props["mask-icon:color"]}
    />
    <link rel="canonical" href={props["og:url"]} />

    {/* OG Tags */}
    <meta property="og:title" content={props["og:title"]} />
    <meta property="og:url" content={props["og:url"]} />
    <meta property="og:description" content={props["og:description"]} />
    <meta property="og:type" content={props["og:type"]} />
    <meta property="og:image" content={props["og:image"]} />
    <meta property="og:image:width" content={props["og:image:width"]} />
    <meta property="og:image:height" content={props["og:image:height"]} />
    <meta property="og:site_name" content={props["og:site_name"]} />

    {/* Twitter Meta */}
    <meta property="twitter:title" content={props["twitter:title"]} />
    <meta property="twitter:site" content={props["twitter:site"]} />
    <meta property="twitter:card" content={props["twitter:card"]} />
    <meta property="twitter:image" content={props["twitter:image"]} />
    <meta
      property="twitter:description"
      content={props["twitter:description"]}
    />
    <meta property="twitter:creator" content={props["twitter:creator"]} />

    {/* Google Meta */}
    <meta itemProp="name" content={props.name} />
    <meta itemProp="description" content={props.description} />
    <meta itemProp="image" content={props.image} />
  </NextHead>
);

Head.propTypes = {
  title: PropTypes.string,
  description: PropTypes.string,
  url: PropTypes.string,
  ogImage: PropTypes.string,
  source: PropTypes.object
};

export default Head;
